import styled from '@emotion/styled';
import { theme } from '../../constants/theme';

export const StyledRadioGroup = styled.div`
  .MuiFormControl-root {
    width: 100%;
  }

  .MuiFormLabel-root {
    color: ${props => props.$error ? theme.colors.error.main : theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.semibold};
    font-size: ${props => props.$size === 'sm' ? theme.typography.fontSize.sm : theme.typography.fontSize.md};
    margin-bottom: ${theme.spacing.sm};

    &.Mui-focused {
      color: ${theme.colors.primary.main};
    }

    &.Mui-disabled {
      color: ${theme.colors.text.disabled};
    }
  }

  .MuiRadioGroup-root {
    gap: ${theme.spacing.xs};
  }

  .MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: ${theme.spacing.lg};
    user-select: none;

    .MuiFormControlLabel-label {
      color: ${props => props.$error ? theme.colors.error.main : theme.colors.text.primary};
      font-size: ${props => props.$size === 'sm' ? theme.typography.fontSize.xs : theme.typography.fontSize.sm};
      font-weight: ${theme.typography.fontWeight.regular};
      
      &.Mui-disabled {
        color: ${theme.colors.text.disabled};
      }
    }
  }

  .MuiRadio-root {
    transition: ${theme.transitions.duration.fast} ${theme.transitions.timing.easeInOut};
    
    &:hover {
      background-color: ${theme.colors.primary.light}15;
    }
  }

  .MuiFormHelperText-root {
    margin-left: 0;
    margin-top: ${theme.spacing.xs};
    font-size: ${theme.typography.fontSize.xs};
    color: ${props => props.$error ? theme.colors.error.main : theme.colors.text.secondary};
  }
`;
